export default "__VITE_ASSET__DwDUYYYK__"